import { render } from "./relay.vue?vue&type=template&id=b9e2fb22&scoped=true&ts=true"
import script from "./relay.vue?vue&type=script&lang=ts"
export * from "./relay.vue?vue&type=script&lang=ts"

import "./relay.vue?vue&type=style&index=0&id=b9e2fb22&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e2fb22"]])

export default __exports__